export default __webpack_public_path__ + "static/media/modeIconDark.4eb37f5f.svg";